export default __webpack_public_path__ + "static/media/Puppies-typeScript-React.b6ee9f3d.jpg";